module.exports = __webpack_public_path__ + "img/vulnerability.a4cc836b.png";